module.exports = __webpack_public_path__ + "media/images/icons/smp_trust-cf74e01aadf3aceb61760a9bd5ee6f44.svg";